const ResponseDialog = ({ type, message, onClose }) => {
    let DialogComponent;

    switch (type) {
        case 'error':
            DialogComponent = ErrorDialog;
            break;
        case 'info':
            DialogComponent = InfoDialog;
            break;
        case 'success':
            DialogComponent = SuccessDialog;
            break;
        default:
            return null; // or a default dialog component
    }

    return (
        <div className="dialog-container">
            <DialogComponent message={message} onClose={onClose} />
        </div>
    );
}

const ErrorDialog = ({ message, onClose }) => {
    return (
        <div className="alert alert-danger" role="alert">
            {message}
        </div>
    );
}

const InfoDialog = ({ message, onClose }) => {
    return (
        <div className="alert alert-info" role="alert">
            {message}
        </div>
    );
}

const SuccessDialog = ({ message, onClose }) => {
    return (
        <div className="alert alert-success" role="alert">
            {message}
        </div>
    );
}
export default ResponseDialog;